import { useTenant } from "../../Contexts/TenantContext";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";

type SocialMediaIconsProps = {
  className?: string;
}

const SocialMediaIcons = ({ className }: SocialMediaIconsProps) => {
  const { tenantContact } = useTenant();

  return (
    <div className={className ?? ""}>
      {tenantContact?.facebookUrl &&
        <a href={tenantContact.facebookUrl} target="_blank" rel="noopener noreferrer">
          <FaFacebook />
        </a>
      }

      {tenantContact?.instagramUrl &&
        <a href={tenantContact.instagramUrl} target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
      }

      {tenantContact?.youTubeUrl &&
        <a href={tenantContact.youTubeUrl} target="_blank" rel="noopener noreferrer">
          <FaYoutube />
        </a>
      }

      {tenantContact?.linkedInUrl &&
        <a href={tenantContact.linkedInUrl} target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a>
      }   
    </div>
  );
};

export default SocialMediaIcons;
